import { useRoutes } from 'react-router-dom';
import { protectedRoutes } from './routes';

export const AppRoutes = () => {
  const element = useRoutes([...protectedRoutes]);
  return <>{element}</>;
};

